module.exports = __webpack_public_path__ + "static/media/loading.492063b3.gif";